export function normalizeTimeSlot(slot) {
  if (slot.entryType) return slot;
  return {
    entryType: "activity",
    time: slot.time || "00:00:00",
    title: slot.planDetails || slot.planDetail || "",
    description: slot.description || "",
    image: slot.image || "",
    lat: slot.lat || null,
    lng: slot.lng || null,
  };
}

export function normalizeDaywisePlan(daywisePlan) {
  if (!Array.isArray(daywisePlan)) return [];
  return daywisePlan.map((day) => ({
    ...day,
    timeSlots: (day.timeSlots || []).map(normalizeTimeSlot),
  }));
}

export function getDayCounts(timeSlots) {
  const counts = { flight: 0, hotel: 0, transfer: 0, activity: 0 };
  for (const slot of timeSlots) {
    if (slot.entryType === "hotel") {
      counts.hotel++;
    } else if (slot.entryType === "activity") {
      counts.activity++;
    } else if (slot.entryType === "transport") {
      if (slot.transportOption?.vehicaltype === "Flight") counts.flight++;
      else counts.transfer++;
    }
  }
  return counts;
}

export function computeStaySummary(days) {
  const stays = [];
  for (const day of days) {
    const slots = (day.timeSlots || []).map(normalizeTimeSlot);
    const hotelSlot = slots.find((s) => s.entryType === "hotel");
    const location = hotelSlot?.hotelName?.label || null;
    if (location) {
      if (stays.length > 0 && stays[stays.length - 1].location === location) {
        stays[stays.length - 1].nights++;
      } else {
        stays.push({ location, nights: 1 });
      }
    }
  }
  return stays.map((s) => `${s.nights}N ${s.location}`).join(", ");
}
